const watcherOptions = {
    attributeFilter: ['class'],
    attributeOldValue: true,
    attributes: true,
    characterData: false,
    characterDataOldValue: false,
    childList: false,
    subtree: false
};
export default class Router {
    constructor(bind, target) {
        this.watching = false;
        this.bind = bind;
        this.target = target || (bind instanceof Document ? bind.body : bind);
    }
    on(typeOrTypes, listener, options) {
        if (typeof typeOrTypes === 'string') {
            this.bind.addEventListener(`${Router.namespace}.${typeOrTypes}`, listener, options);
            return this;
        }
        if (typeOrTypes instanceof Array) {
            typeOrTypes.forEach(listener => this.on(listener.type, listener.handler, listener.options));
            return this;
        }
        Object.keys(typeOrTypes).forEach((type) => {
            const listener = typeOrTypes[type];
            if ('handler' in listener) {
                this.on(type, listener.handler, listener.options);
                return;
            }
            this.on(type, listener);
        });
        return this;
    }
    one(type, listener, options) {
        options = typeof options === 'object' ? options : { passive: options };
        options.once = true;
        this.bind.addEventListener(`${Router.namespace}.${type}`, listener, options);
        return this;
    }
    off(type, listener, options) {
        this.bind.removeEventListener(`${Router.namespace}.${type}`, listener, options);
        return this;
    }
    watch() {
        if (this.watching) {
            return this;
        }
        const observer = new MutationObserver(mutations => {
            mutations
                .filter(mutation => mutation.oldValue)
                .forEach(mutation => {
                const old = mutation.oldValue.split(/\s+/);
                Array.from(mutation.target.classList)
                    .filter(className => old.indexOf(className) === -1)
                    .forEach(this.dispatch.bind(this));
            });
            observer.observe(this.target, watcherOptions);
        });
        observer.observe(this.target, watcherOptions);
        this.watching = true;
        return this;
    }
    fire() {
        Array.from(this.target.classList).forEach(this.dispatch.bind(this));
        return this;
    }
    ready() {
        if (document.readyState !== 'loading') {
            window.setTimeout(this.fire.bind(this), 0);
            return this;
        }
        document.addEventListener('DOMContentLoaded', this.fire.bind(this));
        return this;
    }
    dispatch(className) {
        this.bind.dispatchEvent(new CustomEvent(`${Router.namespace}.${className}`));
        return this;
    }
}
Router.namespace = 'router';
export const router = new Router(document);
